var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Fixed Amount Discount")]),_c('v-list-item-subtitle',[_vm._v("Discount: ₱"+_vm._s(_vm.promoItem.fixedDiscount))]),_c('v-list-item-subtitle',[_vm._v("Remarks: "+_vm._s(_vm.promoItem.remarks))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }